/* notice-sticky-atc.js — sticky Add-to-Cart bars for the new-main-product section
   (.mobile-sticky-add-to-cart / .desktop-sticky-add-to-cart). Extracted from the
   section's inline <script> so the ~12 KB is cached instead of re-sent with every
   product page. Loaded deferred from sections/new-main-product.liquid.
   Responsibilities: show/hide the bars as the buy buttons leave the viewport, keep
   the bar's CTA/price in sync with the selected variant (incl. sold-out -> waitlist),
   submit the real product form, and hide the bars while the cart drawer is open. */
(function () {
  var _footerVisible = false;
  var _trigger = null;
  // Sold-out CTA label comes from the section setting via data-soldout-cta on the bars.
  var _bar = document.querySelector('[data-soldout-cta]');
  var _soldOutCta = (_bar && _bar.getAttribute('data-soldout-cta')) || 'NOTIFY ME';

  /* ── Visibility toggle ── */
  function setBodySticky(active) {
    try { document.documentElement.style.setProperty('--nt-sticky-h', barHeight() + 'px'); } catch (e) {}
    if (_footerVisible && active) return;
    document.body.classList.toggle('notice-sticky-active', active);
  }

  /* ── Footer: hide bar when footer visible, re-show when footer exits ── */
  var _footer = null;
  var _footerObserver = null;
  function initFooterObserver() {
    var footer = document.querySelector('footer.footer');
    if (!footer) return;
    if (_footerObserver) _footerObserver.disconnect();
    _footer = footer;
    _footerObserver = new IntersectionObserver(function(entries) {
      _footerVisible = entries[0].intersectionRatio >= 0.4;
      if (_footerVisible) {
        setBodySticky(false);
      } else if (_trigger && _trigger.getBoundingClientRect().bottom < 0) {
        setBodySticky(true);
      }
    }, { threshold: [0, 0.4] });
    _footerObserver.observe(footer);
  }

  // Theme editor only: re-rendering the footer section swaps in a new <footer>, the observer on the
  // old one never fires again, and the bar's body padding stayed on as a blank band under the footer.
  document.addEventListener('shopify:section:load', function() {
    if (!_footer || !_footer.isConnected) initFooterObserver();
  });

  /* ── IntersectionObserver on the buy buttons area ── */
  // Phones (the mobile bar, max-width 767px): show unless at least half of the buy buttons are on
  // screen, so the first screen has an add-to-cart even when the buttons start just below the fold.
  // Wider screens keep the bar for after the buttons scroll past: there it would cover the price row
  // on the first screen, and the sticky info column brings the buttons into view within ~150px.
  var _phone = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
  var _mobileBar = document.querySelector('.mobile-sticky-add-to-cart');
  function barHeight() { return (_mobileBar && _mobileBar.offsetHeight) || 70; }
  // A02-001 (2 Nov 2026): on a 375x667 phone the 70 px bar sat on the colour-swatch row at scroll 0,
  // so a tap meant for a colour hit the bar and added to cart. While any variant-picker control
  // overlaps the band the bar would cover, keep the bar off; it returns as soon as the picker scrolls
  // clear. Buy buttons a swipe below are still one swipe away.
  function pickerUnderBar() {
    var picker = document.querySelector('variant-selects, .product-form__input--swatch, .product-form__input--pill');
    if (!picker) return false;
    var r = picker.getBoundingClientRect();
    if (r.height === 0) return false;
    var bandTop = window.innerHeight - barHeight();
    return r.bottom > bandTop && r.top < window.innerHeight;
  }
  function wantSticky(rect, ratio) {
    if (_phone && _phone.matches) return ratio < 0.5 && !pickerUnderBar();
    return rect.bottom < 0;
  }
  function visibleRatio(rect) {
    if (rect.height <= 0) return 0;
    var shown = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
    return Math.max(0, shown) / rect.height;
  }
  function evaluate() {
    if (!_trigger) return;
    var rect = _trigger.getBoundingClientRect();
    setBodySticky(wantSticky(rect, visibleRatio(rect)));
  }

  function tryObserve(trigger) {
    if (!trigger) return false;
    _trigger = trigger;
    new IntersectionObserver(function() { evaluate(); }, { threshold: [0, 0.5, 1] }).observe(trigger);
    // Phones: the picker-overlap rule changes between the button thresholds, so re-evaluate on scroll
    // (rAF-throttled; two getBoundingClientRect calls per frame at most).
    var ticking = false;
    function onScroll() {
      if (!(_phone && _phone.matches) || ticking) return;
      ticking = true;
      requestAnimationFrame(function() { ticking = false; evaluate(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // Set initial state immediately
    evaluate();
    return true;
  }

  function getTrigger() {
    // Most specific first: the visible buy buttons, then wider containers as fallbacks. One combined
    // querySelectorAll returned them in DOCUMENT order, so the info column (.product__column-sticky,
    // an ancestor of the buttons) always won; on phones that column is already on screen at load while
    // the buttons sit just below the fold, so the bar stayed hidden and the first screen had no
    // add-to-cart at all (23 Oct 2026: convex-mirror buttons at 846px on an 844px screen).
    var selectors = ['.product-form__buttons', '.product-form__submit', '.product-form', '.product__column-sticky', '.product-form--sticky'];
    var first = null;
    for (var s = 0; s < selectors.length; s++) {
      var candidates = document.querySelectorAll(selectors[s]);
      for (var i = 0; i < candidates.length; i++) {
        if (!first) first = candidates[i];
        if (candidates[i].offsetParent !== null) return candidates[i];
      }
    }
    return first;
  }

  function init() {
    if (tryObserve(getTrigger())) return;
    var attempts = 0;
    var retry = setInterval(function() {
      attempts++;
      if (tryObserve(getTrigger()) || attempts >= 10) {
        clearInterval(retry);
        if (!_trigger) {
          // Fallback: scroll-based
          window.addEventListener('scroll', function() {
            var windowBottom = window.pageYOffset + window.innerHeight;
            setBodySticky(windowBottom < document.documentElement.scrollHeight - 330);
          }, { passive: true });
        }
      }
    }, 200);
  }

  /* ── Sold-out / waitlist sync ── */
  function isSoldOutFromVariant(variant) {
    if (variant && typeof variant.available !== 'undefined') return !variant.available;
    if (document.querySelector('.notice-register-btn')) return true;
    var btn = document.querySelector('.product-form__submit');
    return btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true');
  }

  function syncStickyBtn(btn, variant) {
    if (isSoldOutFromVariant(variant)) {
      btn.textContent = _soldOutCta;
      btn.setAttribute('aria-label', _soldOutCta);
      btn.setAttribute('data-action', 'open-waitlist');
      btn.classList.add('sticky-btn--notify');
      btn.disabled = false;
      btn.style.opacity = '';
      btn.style.cursor = '';
      return;
    }
    btn.removeAttribute('data-action');
    btn.classList.remove('sticky-btn--notify');
    btn.disabled = false;
    btn.style.opacity = '';
    btn.style.cursor = '';
    // Mirror visible submit button text
    var submitBtns = document.querySelectorAll('.product-form__submit');
    for (var i = 0; i < submitBtns.length; i++) {
      if (submitBtns[i].offsetParent !== null) {
        var span = submitBtns[i].querySelector('span:not(.sold-out-message):not(.loading__spinner)');
        if (span) btn.textContent = span.textContent.trim() || btn.textContent;
        break;
      }
    }
    // Accessible name matches the visible label (WCAG 2.5.3), also after a sold-out -> available switch.
    btn.setAttribute('aria-label', btn.textContent.trim());
  }

  /* ── Click: submit the correct product form ── */
  function submitProductForm() {
    var forms = document.querySelectorAll('product-form');
    var target = null;
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i].querySelector('form[data-type="add-to-cart-form"]');
      if (!form) continue;
      var idInput = form.querySelector('input[name="id"]:not([disabled])');
      if (!idInput || !idInput.value) continue;
      var submitBtn = form.querySelector('[type="submit"]');
      if (!submitBtn || submitBtn.disabled || submitBtn.getAttribute('aria-disabled') === 'true') continue;
      if (submitBtn.offsetParent !== null) { target = { form: form, btn: submitBtn }; break; }
      if (!target) target = { form: form, btn: submitBtn }; // keep as fallback
    }
    if (!target) return false;
    if (typeof target.form.requestSubmit === 'function') {
      try { target.form.requestSubmit(target.btn); return true; } catch(e) {}
    }
    target.btn.click();
    return true;
  }

  /* ── Wire up buttons ── */
  function initStickyButtons() {
    var desktopBtn = document.querySelector('.desktop-sticky-add-to-cart__button');
    var mobileBtn  = document.querySelector('.mobile-sticky-add-to-cart__button');

    /**
     * iOS-hardened tap handler for the sticky ATC bar.
     * - Shows the "ADDING…" text on `pointerdown` so the user gets feedback
     *   even if the subsequent `click` is delayed (fast-scroll, low-power).
     * - Avoids the native `disabled` attribute (iOS paints a gray flash that
     *   can mask our custom loading text). Uses aria-disabled + is-loading.
     */
    function enterLoading(btn) {
      if (btn._stickyLoading) return;
      btn._stickyLoading = true;
      btn._stickyOrigText = btn.textContent;
      btn.textContent = 'ADDING...';
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-loading');
    }

    function exitLoading(btn) {
      if (!btn._stickyLoading) return;
      btn._stickyLoading = false;
      if (btn._stickyOrigText != null) btn.textContent = btn._stickyOrigText;
      btn.removeAttribute('aria-disabled');
      btn.removeAttribute('aria-busy');
      btn.classList.remove('is-loading');
    }

    function handleClick(btn) {
      if (btn.hasAttribute('data-action')) return;
      if (btn._stickyLoading) {
        // Pointerdown already entered the loading state — just submit.
        submitProductForm();
      } else {
        enterLoading(btn);
        submitProductForm();
      }
      setTimeout(function () { exitLoading(btn); }, 2000);
    }

    function wireBtn(btn) {
      if (!btn) return;
      var pendingTimer = null;

      function runSubmit() {
        if (btn.hasAttribute('data-action')) return;
        // Guard against a double add-to-cart when the pointerdown fallback
        // timer fires AND the (delayed) click handler also runs for the same
        // tap. Only the first submit per gesture is honored.
        if (btn._stickySubmitGuard) return;
        btn._stickySubmitGuard = true;
        setTimeout(function () { btn._stickySubmitGuard = false; }, 1500);
        submitProductForm();
        setTimeout(function () { exitLoading(btn); }, 2000);
      }

      // Pointerdown provides the earliest paint opportunity on iOS Safari.
      // Fallback: if click doesn't follow within 350ms (touch-cancel, devtools
      // mobile emulation, or some iOS quirks), submit anyway.
      // A thumb that lands on the bar and then scrolls the page never produces a click, and this
      // timer used to add the item anyway (the bar is on screen from the first view on phones). The
      // page scrolls under a fixed bar during a scroll gesture and not during a tap, so a scroll of
      // more than a few px in the window cancels the add.
      btn.addEventListener('pointerdown', function () {
        if (btn.hasAttribute('data-action')) return;
        enterLoading(btn);
        if (pendingTimer) clearTimeout(pendingTimer);
        var startY = window.pageYOffset;
        pendingTimer = setTimeout(function () {
          pendingTimer = null;
          if (Math.abs(window.pageYOffset - startY) > 8) { exitLoading(btn); return; }
          runSubmit();
        }, 350);
      }, { passive: true });

      btn.addEventListener('click', function () {
        if (pendingTimer) { clearTimeout(pendingTimer); pendingTimer = null; }
        if (btn.hasAttribute('data-action')) return;
        if (!btn._stickyLoading) enterLoading(btn);
        runSubmit();
      });

      syncStickyBtn(btn, null);
    }

    wireBtn(desktopBtn);
    wireBtn(mobileBtn);

    /* ── Sticky price ──
       On a normal variant switch product-info.js writes the bar price itself,
       as plain text from the PDP price the server just rendered. This file used
       to overwrite it one tick later with a hard-coded two-decimal format
       ("Rs. 799.00"), which the BUCKS currency app then read as 79,900 rupees
       (a USD visitor saw "$827.36" for a Rs. 799 item).
       Now the bar gets the same markup Liquid's `money` filter renders on page
       load (<span class=money>Rs. 799</span>): copied from the server-rendered
       PDP price in the pub/sub handler, or built from the shop's money format in
       the 'variant:change' fallback, which only runs when no pub/sub update
       follows. A currency app can convert the .money span as it does on load. */
    var MONEY_FORMAT = window.shopMoneyFormat || '{{amount}}'; // set in theme.liquid
    var _priceSeq = 0;

    // Cents -> the shop money format, placeholders and grouping as Liquid's
    // `money` filter (thousands in groups of three: "Rs. 200,000", as the
    // storefront renders it). Returns the format's HTML (<span class=money>).
    function formatMoney(cents, format) {
      var fmt = format || MONEY_FORMAT;
      var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
      if (!m) return '';
      function delimit(precision, thousands, decimal) {
        var n = Number(cents);
        if (!isFinite(n)) return '0';
        var parts = (n / 100).toFixed(precision).split('.');
        var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
        return whole + (parts[1] ? decimal + parts[1] : '');
      }
      var value;
      switch (m[1]) {
        case 'amount_no_decimals':                      value = delimit(0, ',', '.'); break;
        case 'amount_with_comma_separator':             value = delimit(2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = delimit(0, '.', ','); break;
        case 'amount_with_apostrophe_separator':        value = delimit(2, "'", '.'); break;
        case 'amount_no_decimals_with_space_separator': value = delimit(0, ' ', ','); break;
        case 'amount_with_space_separator':             value = delimit(2, ' ', ','); break;
        case 'amount_with_period_and_space_separator':  value = delimit(2, ' ', '.'); break;
        default:                                        value = delimit(2, ',', '.'); // {{amount}}
      }
      return fmt.replace(m[0], value);
    }

    function parseHTML(html) {
      var t = document.createElement('template'); // inert: no scripts, no fetches
      t.innerHTML = String(html).trim();
      return t.content;
    }

    function toText(html) {
      return (parseHTML(html).textContent || '').replace(/\s+/g, ' ').trim();
    }

    // html: server/shop-format markup for the price. Writes only when the bar
    // does not already show that price in that shape. A .money span a currency
    // app has converted in place keeps its original in `bucks-original`.
    function setStickyPrice(html) {
      var text = toText(html);
      if (!text) return;
      var wantsSpan = !!parseHTML(html).querySelector('.money');
      ['.desktop-sticky-add-to-cart__price', '.mobile-sticky-add-to-cart__price'].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (!el) return;
        var money = el.querySelector('.money');
        var shown = money ? (money.getAttribute('bucks-original') || money.textContent).replace(/\s+/g, ' ').trim() : null;
        if (wantsSpan ? shown === text : (!money && el.textContent.trim() === text)) return;
        el.innerHTML = String(html).trim();
      });
    }

    // The section the bars belong to, so a variant change in another product
    // block on the page never writes its price into these bars.
    var _barSection = (function () {
      var bar = document.querySelector('.desktop-sticky-add-to-cart, .mobile-sticky-add-to-cart');
      var sec = bar && bar.closest('.shopify-section');
      return sec && sec.id ? sec.id.replace(/^shopify-section-/, '') : null;
    })();

    document.addEventListener('variant:change', function(e) {
      var v = e.detail && e.detail.variant;
      if (desktopBtn) syncStickyBtn(desktopBtn, v);
      if (mobileBtn)  syncStickyBtn(mobileBtn, v);
      // Fallback price update, only if no pub/sub variantChange follows in this
      // turn (product-info publishes it right after it has written the price).
      if (v && v.price != null) {
        var seq = ++_priceSeq;
        setTimeout(function() {
          if (seq !== _priceSeq) return; // the authoritative handler already synced
          setStickyPrice(formatMoney(v.price));
        }, 0);
      }
    });

    // Authoritative re-sync. The DOM 'variant:change' above is dispatched from
    // product-info.updateURL during an async viewTransition, so it can carry a
    // stale (pre-swap) variant — leaving the sticky bar stuck on "Notify Me"
    // after switching from a sold-out to an available variant (and vice versa).
    // The pub/sub 'variantChange' fires at the END of handleUpdateProductInfo
    // with the correct variant and after the buy buttons have been swapped.
    // Review 4 Nov 2026: the product form's add-to-cart error renders inside the form, which is off-screen exactly
    // when the sticky bar is in use; mirror it on the sticky button for a few seconds.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartError) {
      subscribe(PUB_SUB_EVENTS.cartError, function (ev) {
        if (!ev || ev.source !== 'product-form') return;
        var network = /^(AbortError|TypeError|TimeoutError|network)$/.test(String(ev.errors || ''));
        var text = network ? 'COULD NOT ADD. TAP TO RETRY' : 'NOT ADDED. CHECK QUANTITY';
        [desktopBtn, mobileBtn].forEach(function (btn) {
          if (!btn) return;
          exitLoading(btn);
          clearTimeout(btn._stickyErrT);
          if (btn._stickyErrOrig == null) btn._stickyErrOrig = btn.textContent;
          btn.textContent = text;
          btn.classList.add('is-error');
          btn._stickyErrT = setTimeout(function () {
            if (btn._stickyErrOrig != null) btn.textContent = btn._stickyErrOrig;
            btn._stickyErrOrig = null; btn.classList.remove('is-error');
          }, 3500);
        });
      });
    }
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        var data = ev && ev.data ? ev.data : {};
        var v = data.variant || null;
        if (desktopBtn) syncStickyBtn(desktopBtn, v);
        if (mobileBtn)  syncStickyBtn(mobileBtn, v);
        if (_barSection && data.sectionId && data.sectionId !== _barSection) return;
        _priceSeq++; // cancels the pending 'variant:change' fallback
        // Same source product-info.js copies (the price the server rendered for
        // this variant), keeping its <span class=money> so it matches the PDP.
        var fresh = data.html && typeof data.html.getElementById === 'function' && data.sectionId
          ? data.html.getElementById('price-' + data.sectionId) : null;
        var item = fresh && fresh.querySelector('.price-item--regular, .price-item--sale');
        var html = item && toText(item.innerHTML) ? item.innerHTML : '';
        if (!html && v && v.price != null) html = formatMoney(v.price);
        setStickyPrice(html);
      });
    }
  }

  /* ── Hide the sticky ATC while the cart drawer is open ──
     Observes Dawn's <cart-drawer> `.active` class, which open() adds and
     close() removes. Every open path funnels through those methods
     (cart-icon click, AJAX add-to-cart -> renderContents() -> open(), or a
     programmatic .open()), so this fires for ALL triggers. It edits no Dawn
     core JS, so it survives theme updates. */
  function initCartDrawerSync() {
    function getBars() {
      return [
        document.querySelector('.desktop-sticky-add-to-cart'),
        document.querySelector('.mobile-sticky-add-to-cart')
      ].filter(Boolean);
    }
    function apply(isOpen) {
      document.body.classList.toggle('cart-drawer-open', isOpen);
      // `inert` pulls the hidden bar out of the tab order + a11y tree.
      // The drawer's own focus trap is the baseline; this is belt-and-suspenders.
      getBars().forEach(function (bar) {
        if ('inert' in bar) bar.inert = isOpen;
      });
    }
    function watch(drawer) {
      if (!drawer) return false;
      apply(drawer.classList.contains('active'));
      new MutationObserver(function () {
        apply(drawer.classList.contains('active'));
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      return true;
    }
    if (watch(document.querySelector('cart-drawer'))) return;
    // <cart-drawer> lives in the layout; retry briefly in case our script runs first.
    var attempts = 0;
    var retry = setInterval(function () {
      attempts++;
      if (watch(document.querySelector('cart-drawer')) || attempts >= 10) {
        clearInterval(retry);
      }
    }, 200);
  }

  /* ── Hide the sticky ATC while the product image lightbox is open ──
     #productMediaModal and the bar both sit at z-index 9999 and the bar comes later in the DOM, so
     on 390/430 phones the bar painted over the lightbox's bottom nav (A02 / C6). Mirrors the cart
     drawer sync: watch the modal's `open` class, toggle a body class the CSS hides on, inert the bar. */
  function initLightboxSync() {
    var modal = document.getElementById('productMediaModal');
    if (!modal || typeof MutationObserver !== 'function') return;
    function apply() {
      var isOpen = modal.classList.contains('open');
      document.body.classList.toggle('notice-lightbox-open', isOpen);
      [document.querySelector('.desktop-sticky-add-to-cart'), document.querySelector('.mobile-sticky-add-to-cart')]
        .forEach(function (bar) { if (bar && 'inert' in bar) bar.inert = isOpen || document.body.classList.contains('cart-drawer-open'); });
    }
    apply();
    new MutationObserver(apply).observe(modal, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(); initStickyButtons(); initFooterObserver(); initCartDrawerSync(); initLightboxSync(); });
  } else {
    init(); initStickyButtons(); initFooterObserver(); initCartDrawerSync(); initLightboxSync();
  }

})();
